import { Component, OnInit } from '@angular/core';
import { ApiService, StorageService } from '../../_services';
import { Router } from '@angular/router';
import { INavData } from '@coreui/angular';
import { FirebaseLoginService } from '../../_services/firebase-login.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['default-layout.component.scss']
})

export class DefaultLayoutComponent implements OnInit {
  public navItems = [];
  public sidebarMinimized = true;
  public sidebar;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  public user: string;

  year = new Date().getFullYear();

  public menuClicked = false;

  constructor(
    private _loginFirebase: FirebaseLoginService,
    private _api: ApiService,
    private _route: Router,
    private _storage: StorageService,
  ) {
    this.changes = new MutationObserver((mutations) => {

      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });

    this.changes.observe(<Element>this.element, {
      attributes: true
    });
  }

  ngOnInit() {
    this.loadData();
    this.user = this._storage.getUser();
  }

  loadData() {
    const sidebar = document.getElementsByTagName('body');
    sidebar[0].setAttribute('class', 'sidebar-minimized brand-minimized');
    this._api.getMenu().subscribe(res => {
      const items = [];
      res.forEach(r => {
        const newItem: INavData = {
          name: r.title,
          url: r.location,
          icon: r.icon
        };
        if (r.subMenu && r.subMenu.length > 0) {
          newItem.children = [];
          for (const subItem of r.subMenu) {
            const newSub = {
              name: subItem.title,
              url: subItem.location,
              icon: subItem.icon
            };
            newItem.children.push(newSub);
          }
        }
        items.push(newItem);
      });
      this.navItems = items;
    });
    this.user = this._storage.getUser();
  }

  openMenu() {

    if (!this.menuClicked) {
      this.menuClicked = true;
      const sidebarMobile = document.getElementsByTagName('App-sidebar');
      sidebarMobile[0].setAttribute('style', 'margin-left:0;');
      const body = document.getElementsByClassName('container-fluid');
      body[0].setAttribute('style', 'opacity:0.4');
    } else {
      this.menuClicked = false;
      const sidebarMobile = document.getElementsByTagName('App-sidebar');
      sidebarMobile[0].setAttribute('style', 'margin-left:-200px;');
      const body = document.getElementsByClassName('container-fluid');
      body[0].setAttribute('style', 'opacity:1.0');

    }
  }

  logout() {
    this._loginFirebase.signOut();
    this._route.navigate(['login']);
  }


}
